import { render, staticRenderFns } from "./AchievementsBanner.vue?vue&type=template&id=83afa616&scoped=true&lang=pug&"
var script = {}
import style0 from "./AchievementsBanner.vue?vue&type=style&index=0&id=83afa616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83afa616",
  null
  
)

export default component.exports